module.exports = __webpack_public_path__ + "assets/img/Edito_Bertrand-Cozzarolo_menu.1bf83c60-ps.jpg";